import {
  UserPermissionKeyType,
  UserPermissionType,
} from '@gasbi/shared/common/components/Permissions/types';

export const UserPermissions: Partial<
  Record<UserPermissionKeyType, UserPermissionType>
> = {
  // 1 Фактичний облік
  // 1.1 Фактична витрата
  ActualAccountingActualExpenseWrite: 'actualaccounting.actualexpense.write',
  ActualAccountingActualExpenseDelete: 'actualaccounting.actualexpense.delete',
  ActualAccountingActualExpenseRead: 'actualaccounting.actualexpense.read', // Done
  // 1.5 Вивантаження акту приймання-передачі
  ActualAccountingTransferActManage: 'actualaccounting.transferact.manage',
  // 1.2 Фактичне надходження
  ActualAccountingActualIncomeWrite: 'actualaccounting.actualincome.write',
  ActualAccountingActualIncomeDelete: 'actualaccounting.actualincome.delete',
  ActualAccountingActualIncomeRead: 'actualaccounting.actualincome.read', // Done
  ActualAccountingConsumerIndicatorRead:
    'actualaccounting.consumerindicator.read', // Done
  // 1.3 Річна замовлена потужність
  ActualAccountingAnnualOrderedCapacityWrite:
    'actualaccounting.annualorderedcapacity.write',
  ActualAccountingAnnualOrderedCapacityDelete:
    'actualaccounting.annualorderedcapacity.delete',
  ActualAccountingAnnualOrderedCapacityRead:
    'actualaccounting.annualorderedcapacity.read', // Done
  // 1.4 Нитка ГРС фізико хімічні показники (ФХП)
  ActualAccountingGasThreadPhysicoChemicalIndicatorWrite:
    'actualaccounting.gasthreadphysicochemicalindicator.write',
  ActualAccountingGasThreadPhysicoChemicalIndicatorDelete:
    'actualaccounting.gasthreadphysicochemicalindicator.delete',
  ActualAccountingGasThreadPhysicoChemicalIndicatorRead:
    'actualaccounting.gasthreadphysicochemicalindicator.read', // Done
  // 1.5 Перевищення РЗП
  ActualAccountingOrderedCapacityExcessRead:
    'actualaccounting.orderedcapacityexcess.read',
  ActualAccountingOrderedCapacityExcessWrite:
    'actualaccounting.orderedcapacityexcess.write',
  ActualAccountingOrderedCapacityExcessDelete:
    'actualaccounting.orderedcapacityexcess.delete',
  // 1.6 Розрахунок РЗП за замовчуванням
  ActualAccountingOrderedCapacityCalculateByDefaultManage:
    'actualaccounting.orderedcapacitycalculatebydefault.manage',

  // 2 Адміністрування
  // 2.1 Користувачи
  AdministrationUserManage: 'administration.user.manage',
  AdministrationUserRead: 'administration.user.read',
  // 2.2 Тарифи з розподілу
  AdministrationDistributionTariffRead:
    'administration.distributiontariff.read',
  AdministrationDistributionTariffManage:
    'administration.distributiontariff.manage',
  // 2.3 API Ключі
  AdministrationApiKeysRead: 'administration.apikeys.read',
  AdministrationApiKeysManage: 'administration.apikeys.manage',
  // 2.x Сесії користувачів
  AdministrationSessionsRead: 'administration.sessions.read',
  AdministrationSessionsManage: 'administration.sessions.manage',
  // 2.4 Підсистеми
  AdministrationSubsystemRead: 'administration.subsystem.read',
  AdministrationSubsystemManage: 'administration.subsystem.manage',
  // 2.5 Робочі періоди
  AdministrationWorkingPeriodRead: 'administration.workingperiod.read',
  AdministrationWorkingPeriodManage: 'administration.workingperiod.manage',
  // 2.6 SSO інтеграції
  AdministrationSSOIntegrationsRead: 'administration.ssointegrations.read',
  AdministrationSSOIntegrationsManage: 'administration.ssointegrations.manage',
  // 2.7 Довідники
  AdministrationCatalogRead: 'administration.catalog.read',
  AdministrationCatalogManage: 'administration.catalog.manage',

  // 2 організації
  // 2.1 Співробітники
  OrganizationsEmployeeManage: 'organizations.employee.manage', // Done
  OrganizationsEmployeeRead: 'organizations.employee.read', // Done
  // 2.2 Організації
  OrganizationsOrganizationManage: 'organizations.organization.manage', // Done
  OrganizationsOrganizationRead: 'organizations.organization.read', // Done
  // 2.3 ReferenceBook
  OrganizationsReferenceBookManage: 'organizations.referencebook.manage', // Done
  OrganizationsReferenceBookRead: 'organizations.referencebook.read', // Done
  // 2.4 Ролі та дозвіли
  OrganizationsRoleAndPermissionManage:
    'organizations.roleandpermission.manage', // Done
  OrganizationsRoleAndPermissionRead: 'organizations.roleandpermission.read', // Done
  // 2.5 Структурні підрозділи
  OrganizationsStructuralSubdivisionManage:
    'organizations.structuralsubdivision.manage', // Done
  OrganizationsStructuralSubdivisionRead:
    'organizations.structuralsubdivision.read', // Done
  // 2.6 Групи Користувачів
  OrganizationsUserGroupManage: 'organizations.usergroup.manage',
  OrganizationsUserGroupRead: 'organizations.usergroup.read',
  // 2.7 Головна організація
  OrganizationsMainOrganizationManage: 'organizations.mainorganization.manage',

  // 3 Комерційні споживачі
  // 3.2 Комерційні точки обліку
  CommercialConsumersCommercialMeteringPointWrite:
    'commercialconsumers.commercialmeteringpoint.write', // Done
  CommercialConsumersCommercialMeteringPointDelete:
    'commercialconsumers.commercialmeteringpoint.delete',
  CommercialConsumersCommercialMeteringPointRead:
    'commercialconsumers.commercialmeteringpoint.read', // Done
  // 3.3 Комерційні точки обліку запит на код
  CommercialConsumersCommercialMeteringPointCodeRequestWrite:
    'commercialconsumers.commercialmeteringpointcoderequest.write',
  CommercialConsumersCommercialMeteringPointCodeRequestDelete:
    'commercialconsumers.commercialmeteringpointcoderequest.delete',
  CommercialConsumersCommercialMeteringPointCodeRequestRead:
    'commercialconsumers.commercialmeteringpointcoderequest.read',
  // 3.4 Комерційні точки обліку переміщення
  CommercialConsumersCommercialMeteringPointOwnershipWrite:
    'commercialconsumers.commercialmeteringpointownership.write', // Done
  CommercialConsumersCommercialMeteringPointOwnershipDelete:
    'commercialconsumers.commercialmeteringpointownership.delete',
  CommercialConsumersCommercialMeteringPointOwnershipRead:
    'commercialconsumers.commercialmeteringpointownership.read', // Done
  // 3.5 Розрахунок підключеної потужності
  CommercialConsumersConnectedPowerCalculationManage:
    'commercialconsumers.connectedpowercalculation.manage', // Done
  // 3.6 Договори
  CommercialConsumersContractWrite: 'commercialconsumers.contract.write', // Done
  CommercialConsumersContractDelete: 'commercialconsumers.contract.delete',
  CommercialConsumersContractRead: 'commercialconsumers.contract.read', // Done
  // 3.7 Контрагенти
  CommercialConsumersCounterpartyWrite:
    'commercialconsumers.counterparty.write', // Done
  CommercialConsumersCounterpartyDelete:
    'commercialconsumers.counterparty.delete',
  CommercialConsumersCounterpartyRead: 'commercialconsumers.counterparty.read', // Done
  // 3.7.1 Контрагенти- контантні особи
  CommercialConsumersCounterpartyContactPersonWrite:
    'commercialconsumers.counterpartycontactperson.write',
  CommercialConsumersCounterpartyContactPersonDelete:
    'commercialconsumers.counterpartycontactperson.delete', // Done
  // 3.8 Редагування коду ЕІС
  CommercialConsumersEICManage: 'commercialconsumers.eic.manage', // Done
  // 3.9 Газоспоживаюче обладнання
  CommercialConsumersGasConsumingEquipmentWrite:
    'commercialconsumers.gasconsumingequipment.write', // Done
  CommercialConsumersGasConsumingEquipmentDelete:
    'commercialconsumers.gasconsumingequipment.delete',
  CommercialConsumersGasConsumingEquipmentRead:
    'commercialconsumers.gasconsumingequipment.read', // Done
  // 3.10 Вузол обліку газу (ВОГ)
  CommercialConsumersGasMeteringNodeWrite:
    'commercialconsumers.gasmeteringnode.write', // Done
  CommercialConsumersGasMeteringNodeDelete:
    'commercialconsumers.gasmeteringnode.delete',
  CommercialConsumersGasMeteringNodeRead:
    'commercialconsumers.gasmeteringnode.read', // Done
  // 3.11 Ділянки газопроводу
  CommercialConsumersGasPipelineSectionWrite:
    'commercialconsumers.gaspipelinesection.write',
  CommercialConsumersGasPipelineSectionDelete:
    'commercialconsumers.gaspipelinesection.delete',
  CommercialConsumersGasPipelineSectionRead:
    'commercialconsumers.gaspipelinesection.read', // Done
  // 3.12 Прилади обліку
  CommercialConsumersMeteringDeviceWrite:
    'commercialconsumers.meteringdevice.write', // Done
  CommercialConsumersMeteringDeviceDelete:
    'commercialconsumers.meteringdevice.delete', // Done
  CommercialConsumersMeteringDeviceRead:
    'commercialconsumers.meteringdevice.read', // Done
  // 3.13 Акт по Точки обліку ГРС
  CommercialConsumersMeteringPointDocumentWrite:
    'commercialconsumers.meteringpointdocument.write', // Done
  CommercialConsumersMeteringPointDocumentDelete:
    'commercialconsumers.meteringpointdocument.delete', // Done
  CommercialConsumersMeteringPointDocumentRead:
    'commercialconsumers.meteringpointdocument.read', // Done
  // 3.14 Пломби
  CommercialConsumersSealWrite: 'commercialconsumers.seal.write', // Done
  CommercialConsumersSealDelete: 'commercialconsumers.seal.delete', // Done
  CommercialConsumersSealRead: 'commercialconsumers.seal.read', // Done
  // 3.15 Документи контрагента
  CommercialConsumersCounterpartyDocumentWrite:
    'commercialconsumers.counterpartydocument.write',
  CommercialConsumersCounterpartyDocumentRead:
    'commercialconsumers.counterpartydocument.read',

  // 4 ГРС
  // 4.1 Газоспоживаюче обладнання
  GasDistributionStationGasConsumingEquipmentWrite:
    'gasdistributionstation.gasconsumingequipment.write', // Done
  GasDistributionStationGasConsumingEquipmentDelete:
    'gasdistributionstation.gasconsumingequipment.delete',
  GasDistributionStationGasConsumingEquipmentRead:
    'gasdistributionstation.gasconsumingequipment.read', // Done
  // 4.2 Вузол обліку газу (ВОГ)
  GasDistributionStationGasMeteringNodeWrite:
    'gasdistributionstation.gasmeteringnode.write', // Done
  GasDistributionStationGasMeteringNodeDelete:
    'gasdistributionstation.gasmeteringnode.delete',
  GasDistributionStationGasMeteringNodeRead:
    'gasdistributionstation.gasmeteringnode.read', // Done
  // 4.3 Маршрути
  GasDistributionStationGasRouteWrite: 'gasdistributionstation.gasroute.write',
  GasDistributionStationGasRouteDelete:
    'gasdistributionstation.gasroute.delete',
  GasDistributionStationGasRouteRead: 'gasdistributionstation.gasroute.read', // Done
  // 4.4 ГРС
  GasDistributionStationGDSRead: 'gasdistributionstation.gds.read', // Done
  GasDistributionStationGDSDelete: 'gasdistributionstation.gds.delete',
  GasDistributionStationGDSWrite: 'gasdistributionstation.gds.write', // Done
  // 4.5 ГРС Проектна потужність (out of MVP)
  GasDistributionStationGDSDesignCapacityWrite:
    'gasdistributionstation.gdsdesigncapacity.write',
  GasDistributionStationGDSDesignCapacityDelete:
    'gasdistributionstation.gdsdesigncapacity.delete',
  GasDistributionStationGDSDesignCapacityRead:
    'gasdistributionstation.gdsdesigncapacity.read',
  // 4.6 Прилади обліку
  GasDistributionStationMeteringDeviceWrite:
    'gasdistributionstation.meteringdevice.write', // Done
  GasDistributionStationMeteringDeviceDelete:
    'gasdistributionstation.meteringdevice.delete', // Done
  GasDistributionStationMeteringDeviceRead:
    'gasdistributionstation.meteringdevice.read', // Done
  // 4.7 Точки обліку ГРС
  GasDistributionStationMeteringPointWrite:
    'gasdistributionstation.meteringpoint.write', // Done
  GasDistributionStationMeteringPointDelete:
    'gasdistributionstation.meteringpoint.delete',
  GasDistributionStationMeteringPointRead:
    'gasdistributionstation.meteringpoint.read', // Done
  // 4.8 Акт по Точки обліку ГРС
  GasDistributionStationMeteringPointActWrite:
    'gasdistributionstation.meteringpointact.write', // Done
  GasDistributionStationMeteringPointActDelete:
    'gasdistributionstation.meteringpointact.delete',
  GasDistributionStationMeteringPointActRead:
    'gasdistributionstation.meteringpointact.read', // Done
  // 4.9 Оперативний маршрут транспортування газу (Діючі маршрути)
  GasDistributionStationOperatingGasRouteWrite:
    'gasdistributionstation.operatinggasroute.write', // Done
  GasDistributionStationOperatingGasRouteDelete:
    'gasdistributionstation.operatinggasroute.delete',
  GasDistributionStationOperatingGasRouteRead:
    'gasdistributionstation.operatinggasroute.read', // Done
  // 4.10 Пломби
  GasDistributionStationSealWrite: 'gasdistributionstation.seal.write', // Done
  GasDistributionStationSealDelete: 'gasdistributionstation.seal.delete', // Done
  GasDistributionStationSealRead: 'gasdistributionstation.seal.read', // Done
  // 4.11 Сектори
  GasDistributionStationSectorWrite: 'gasdistributionstation.sector.write', // Done
  GasDistributionStationSectorDelete: 'gasdistributionstation.sector.delete',
  GasDistributionStationSectorRead: 'gasdistributionstation.sector.read', // Done
  // 4.12 Перемички
  GasDistributionStationSectorBridgeWrite:
    'gasdistributionstation.sectorbridge.write', // Done
  GasDistributionStationSectorBridgeDelete:
    'gasdistributionstation.sectorbridge.delete',
  GasDistributionStationSectorBridgeRead:
    'gasdistributionstation.sectorbridge.read', // Done
  // 4.13 Акти по Перемичкам
  GasDistributionStationSectorBridgeActWrite:
    'gasdistributionstation.sectorbridgeact.write', // Done
  GasDistributionStationSectorBridgeActDelete:
    'gasdistributionstation.sectorbridgeact.delete',
  GasDistributionStationSectorBridgeActRead:
    'gasdistributionstation.sectorbridgeact.read', // Done
  // 4.14 Нитки ГРС
  GasDistributionStationThreadWrite: 'gasdistributionstation.thread.write', // Done
  GasDistributionStationThreadDelete: 'gasdistributionstation.thread.delete',
  GasDistributionStationThreadRead: 'gasdistributionstation.thread.read', // Done

  // 5 Оперативний облік
  // 5.1 Споживачі без номінації
  OperationalAccountingConsumersWithoutNominationRead:
    'operationalaccounting.consumerswithoutnomination.read', // Done
  OperationalAccountingConsumersWithoutNominationWrite:
    'operationalaccounting.consumerswithoutnomination.write', // Done
  OperationalAccountingConsumersWithoutNominationDelete:
    'operationalaccounting.consumerswithoutnomination.delete',
  // 5.2 Експорт
  OperationalAccountingExportRead: 'operationalaccounting.export.read', // Done
  // 5.3 Оперативна витрата
  OperationalAccountingOperationalExpenseRead:
    'operationalaccounting.operationalexpense.read', // Done
  OperationalAccountingOperationalExpenseWrite:
    'operationalaccounting.operationalexpense.write',
  OperationalAccountingOperationalExpenseDelete:
    'operationalaccounting.operationalexpense.delete',
  // 5.4 Оперативне надходження
  OperationalAccountingOperationalIncomeRead:
    'operationalaccounting.operationalincome.read', // Done
  OperationalAccountingOperationalIncomeWrite:
    'operationalaccounting.operationalincome.write',
  OperationalAccountingOperationalIncomeDelete:
    'operationalaccounting.operationalincome.delete',
  // 5.5 Оперативне надходження
  OperationalAccountingLastResortSupplierRead:
    'operationalaccounting.lastresortsupplier.read', // Done
  OperationalAccountingLastResortSupplierWrite:
    'operationalaccounting.lastresortsupplier.write', // Done

  // 6 Звіти та аналітика
  ReportsAndAnalyticsReportRead: 'reportsandanalytics.report.read',
  ReportsAndAnalyticsReportWrite: 'reportsandanalytics.report.write',
  ReportingAndAnalyticsReportDelete: 'reportingandanalytics.report.delete',
  ReportingAndAnalyticsGasDistributionRead:
    'reportingandanalytics.gasdistribution.read',
  ReportingAndAnalyticsMonitoringRead: 'reportingandanalytics.monitoring.read',
  //7 Загальні
  GeneralGasbiSupportRead: 'general.gasbisupport.read',
};
